import React from 'react';
import './Footer.css';
// Importando ícones mais femininos
import { FaHeart, FaInstagram, FaFacebook, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3><FaHeart className="heart-icon" /> Floratta Cosméticos</h3>
            <p>Beleza e cuidados que transformam seu dia. Produtos selecionados com carinho para realçar sua beleza natural.</p>
            <p className="footer-tagline">✨ Cuide-se com amor ✨</p>
          </div>
          
          <div className="footer-section">
            <h3>Links Rápidos</h3>
            <ul className="footer-links">
              <li><a href="/"><span className="link-icon">♡</span> Início</a></li>
              <li><a href="/#produtos"><span className="link-icon">♡</span> Produtos</a></li>
              <li><a href="/#categorias"><span className="link-icon">♡</span> Categorias</a></li>
              <li><a href="/mega-oferta"><span className="link-icon">♡</span> Ofertas Especiais</a></li>
              <li><a href="/#contato"><span className="link-icon">♡</span> Contato</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Fale Conosco</h3>
            <p><span className="contact-label">Email:</span> contato@floratta.com</p>
            <p><span className="contact-label">Telefone:</span> (94) 98153-6324</p>
            <p className="address-info">
              <span className="contact-label">Endereço:</span> 
              <span className="address-text">
                <FaMapMarkerAlt className="address-icon" /> Rua A, Quadra 48 Casa 04 - Viva Cidade - Tucuruí-PA
              </span>
            </p>
            <p className="hours-info">
              <span className="contact-label">Horário:</span>
              <span className="hours-text">
                Segunda a Quinta: 09h às 21h<br/>
                Sexta: 09h às 18h<br/>
                Sábado: 18h às 21h
              </span>
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/floratta.cosmestico" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
              <a href="https://www.instagram.com/floratta.cosmeticos/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>

          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-decoration">
            <span className="flower">❀</span>
            <span className="line"></span>
            <span className="heart">♡</span>
            <span className="line"></span>
            <span className="flower">❀</span>
          </div>
          <p>&copy; {currentYear} Floratta Cosméticos. Todos os direitos reservados.</p>
          <p className="footer-motto">Beleza que vem de dentro, cuidados que vêm de nós</p>
          <p className="footer-credits">Site desenvolvido por Tecnet Informatica - By Clécio Alves</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
